<script>
    import { onDestroy, getContext } from 'svelte'
    import _             from 'lodash'
    import * as api      from '../../shared/api.js'
    import Item          from '../../shared/Item.svelte'
    import Cookie        from './Cookie.svelte'

    export let groups
    export let item
    export let active

    let expanded  = -1
    let mode      = ''

    let removing    = false
    let removeError = false
    let updating    = true

    const ctx  = getContext('cookies')
    
    onDestroy(() => {
        expanded = -1
        mode     = ''
    })

    function isDirty(item, copy) {
        return ! _.isEqual(item, copy)
    }

    function empty(group) {
        return { id: 0, group: group, name: '', description: '', purpose: '', provider: '' }
    }

    function onUpdate(group) {
        const obj = _.omitBy(group, i => i === '')
        return api
            .put('/donut/group', obj)
            .then(api.toJsonIf200)
            .then(it => {
                ctx.groupUpdated(it)
                // if(copy.id > 0) copy = { ...cookie }
                // toggle('edit')
                return it
            })
            .catch(err => {
                if(err.status === 400) {
                    err.json().then(violations => {
                        console.log(violations)
                    })
                }
                return Promise.reject('erro atualizando grupo')
            })
    }

    function onRemove(group) {
        return api
            .del(`/donut/group/${group.id}`)
            .then(api.toTextIf200)
            .then(() => {
                ctx.groupRemoved(group)
                return true
            })
            .catch(err => {
                return Promise.reject(err)
            })
    }

    function actionsGiven(count) {
        return [
            {
                name: `${count} Cookies`, 
                triggerLoading: true,
                disabled: false,
                onClick: () => { 
                    expanded = -1
                    return Promise.resolve(true)
                }
            }
        ]

    }

    $: cookieCount  = item.cookies.length
    $: withCookies  = cookieCount > 0
    $: addActive    = !withCookies || (mode === 'addCookie' && expanded === -1)
    $: actions      = actionsGiven(cookieCount)

</script>

<style>

    .item .ui.label {
        width: 110px;
    }

    .item {
        margin: 1em 0;
    }

    .ui.checkbox {
        margin: 1em 0 1em 135px;
    }

    .ui.checkbox label {
        font-size: 18px !important;
    }

    .cookie.item {
        display: flex;
        align-items: flex-end;
        padding: 1em !important;
    }

    .cookie.list {
        overflow: hidden;
        background-color: var(--main-bg-color);
        transition: all .7s cubic-bezier(0, 1, 0.5, 1);
        /* border: 1px solid red;     */
    }

    .cookie.list.active {
        margin: 20px 0;
        padding: 30px;
        border-radius: 3px;
        opacity: 1;
        overflow: visible;
    }

    .cookie.list:not(.active) {
        margin  : 0;
        padding : 0;
        height  : 0;
        opacity : 0;
        overflow: hidden;
    }

    .detail {
        color       : #444;
        font-size   : 10pt;
        font-style  : normal;
        font-weight : normal;
    }

</style>

<Item bind:item={item} bind:active={active} {isDirty} {onUpdate} {onRemove} {actions} debug={false}>
    <span slot="header">
        <span class="name">         {item.name} {#if item.required}<b class="detail">obrigatório</b>{/if}</span>
        <span class="description">  {item.description}  </span>
        <!-- <span>
            Active: {active} - Expanded: {expanded}
        </span> -->
    </span>
    <div slot="primary">
        <div class="item">
            <div class="ui toggle big checkbox">
                <input type="checkbox" bind:checked={item.required}>
                <label>Obrigatório</label>
            </div>
        </div>
        <div class="item">
            <div class="ui labeled big input" >
            <div class="ui label">Nome</div>
                <input  bind:value={item.name}
                        type="text"
                        autocomplete="false">
            </div>
        </div>
        <div class="item">
            <div class="ui labeled big input" >
            <div class="ui label">Descrição</div>
                <input  bind:value={item.description}
                        type="text" 
                        autocomplete="false">
            </div>
        </div>
    </div>
    <div slot="secondary">
        {#if item.id === active}
            <div class="cookie item">
                <div style="flex: 1"></div>
                {#if !withCookies}
                    <div class="ui big message">
                        Adicione o primeiro cookie ao grupo <b>{item.name}</b>
                    </div>
                {:else}
                    <button class="ui primary button"
                            class:disabled={mode == 'addCookie'}
                            on:click={e => mode = 'addCookie'}>
                        Adicionar cookie
                    </button>
                {/if}
            </div>
            <div    style="background-color: #fff"
                    class="cookie list" 
                    class:active={addActive}>
                <div class="cookie item form" >
                    <div style="flex: 1">
                        <Cookie {isDirty}
                                group={item}
                                cookie={ empty(item.id) }
                                expanded={ 0 }
                                nobar={true}
                                mode='edit' 
                                onCancel={ () => mode = '' }
                                closeOnCancel={false} />
                    </div>
                </div>
            </div>
            <div class="ui divided selection cookie list" class:active={withCookies}>
                {#each item.cookies as cookie (cookie.id)}
                    <div class="cookie item">
                        <div style="flex: 1">
                            <Cookie
                                group={item}
                                {groups}
                                {isDirty} 
                                {cookie}
                                bind:expanded={expanded}
                            />
                        </div>
                    </div>
                {/each}
            </div>
        {/if}
    </div>
</Item>